export class DestinationDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerSpecificConfig",
            "baseName": "providerSpecificConfig",
            "type": "DestinationProviderAttributes",
            "format": ""
        },
        {
            "name": "typeSpecificConfig",
            "baseName": "typeSpecificConfig",
            "type": "DestinationRestoreTypeAttributes",
            "format": ""
        },
        {
            "name": "restoreResult",
            "baseName": "restoreResult",
            "type": "RestoreResult",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DestinationDetails.attributeTypeMap;
    }
    constructor() {
    }
}
